<template>
  <div>
    <div class="partner-info">
      <div class="ach-panel">
        <div class="ach-warp">
          <div class="personal-info" @click="toLink('/partner-info-edit')">
            <van-image fit="cover" :src="partnerInfo.avatar || avatar" class="avatar" />
            <div class="personal-right">
              <p class="personal-name">{{ !pageInit ? '请登录' : partnerInfo.sales.name }}</p>
              <p class="personal-tel">
                <!-- {{ !pageInit ? '登录后查看更多' : partnerInfo.phone }} -->
                {{ !pageInit ? '登录后查看更多' : $getGender(partnerInfo.sales.gender) }}
              </p>
            </div>
          </div>
          <div class="ach-content">
            <div>
              <p class="ach-title">诊所数</p>
              <p class="ach-num"><countTo separator="" :startVal="0" :endVal="scoreInfo.clinicAmount" /></p>
            </div>
            <div>
              <p class="ach-title">设备数</p>
              <p class="ach-num"><countTo separator="" :startVal="0" :endVal="scoreInfo.machineAmount" /></p>
            </div>
            <div>
              <p class="ach-title">打卡数</p>
              <p class="ach-num"><countTo separator="" :startVal="0" :endVal="scoreInfo.signinAmount" /></p>
            </div>
            <div>
              <p class="ach-title">上月销量</p>
              <p class="ach-num"><countTo separator="" :startVal="0" :endVal="scoreInfo.lmSalseAmount" /></p>
            </div>
            <div>
              <p class="ach-title">本月销量</p>
              <p class="ach-num"><countTo separator="" :startVal="0" :endVal="scoreInfo.salseAmount" /></p>
            </div>
          </div>
        </div>
      </div>

      <div class="personal-func-warp">
        <div class="func-warp">
          <div
            class="func-item"
            v-for="(item, index) in funcList.filter(i => !i.show || i.show())"
            :key="index"
            is-link
            @click="toLink(item.link)"
          >
            <i :class="['iconfont', item.icon]" />
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div class="personal-func-list" v-if="false">
        <cell
          v-for="(item, index) in funcList.filter(i => !i.show || i.show())"
          :key="index"
          is-link
          @click="toLink(item.link)"
        >
          <template #title>
            <span :class="['iconfont', `${item.icon}`]"></span>
            <span class="custom-title">{{ item.label }}</span>
          </template>
          <template #right-icon>
            <div class="right">
              <icon name="arrow" />
            </div>
          </template>
        </cell>
      </div>
    </div>
    <div style="height:200px" />

    <opinion v-show="opinionModel.show" :show.sync="opinionModel.show" :info="opinionModel.info" />
    <qrcode v-if="qrcodeModel.show" :show.sync="qrcodeModel.show" :info="qrcodeModel.info" />

    <tabbar :curIndex="2" />
  </div>
</template>

<script>
import countTo from 'vue-count-to';
import tabbar from '../components/tabbar';
import opinion from '@/components/opinion';
import qrcode from '@/components/qrcode';

import services from '@/service';

import { Cell, Icon, Image as VanImage } from 'vant';
import { mapGetters } from 'vuex';
import { signOut, inviteUrl } from '@/lib/utils';
import { notRequest, checkLogin } from '@/lib/utils';

// import { adminAuth } from '@/global';

export default {
  components: { countTo, tabbar, opinion, qrcode, Cell, Icon, VanImage },
  data() {
    return {
      avatar: this.$getImg('avatar'),
      opinionModel: {
        show: false,
        info: {}
      },
      qrcodeModel: {
        show: false,
        info: {}
      },
      pullLoading: false,
      scoreInfo: {
        clinicAmount: 0,
        machineAmount: 0,
        signinAmount: 0,
        lmSalseAmount: 0,
        salseAmount: 0,
        withdrawalAmount: 0
      },
      searchVal: ''
    };
  },
  mounted() {
    if (!this.pageInit) return;

    this.refresh();
  },
  computed: {
    ...mapGetters(['partnerInfo', 'partnerId']),
    pageInit() {
      return !notRequest();
    },
    funcList() {
      return [
        {
          label: '基本信息',
          icon: 'icon-jbxx',
          link: '/partner-info-edit'
        },
        // {
        //   label: '我的订单',
        //   icon: 'icon-wddd',
        //   link: '/partner-my-order'
        // },
        // {
        //   label: '我的诊所',
        //   icon: 'icon-wdzs',
        //   link: '/partner-my-clinic'
        // },
        // {
        //   label: '我的设备',
        //   icon: 'icon-wdsb',
        //   link: '/partner-device-list'
        // },
        {
          label: '业绩统计',
          icon: 'icon-cw',
          link: '/partner-finance'
        },
        {
          label: '收货人管理',
          icon: 'icon-sh',
          link: '/partner-my-address'
        },
        // {
        //   label: '设备申请记录',
        //   icon: 'icon-jl',
        //   link: '/partner-device-apply-record'
        // },
        // {
        //   label: '业务员设备库存',
        //   icon: 'icon-wdsb',
        //   link: '/partner-stock-device-sales'
        // },
        // {
        //   label: '业务员耗材库存',
        //   icon: 'icon-kcgl',
        //   link: '/partner-stock-sales'
        // },
        // {
        //   label: '二维码名片',
        //   icon: 'icon-ewm',
        //   link: 'qrcode'
        // },
        // {
        //   label: '后台管理',
        //   icon: 'icon-htgl',
        //   link: '/admin-login',
        //   show() {
        //     return adminAuth.includes('18664529512');
        //   }
        // },
        {
          label: '意见反馈',
          icon: 'icon-kf',
          link: 'opinion'
        },
        {
          label: '退出登录',
          icon: 'icon-tc',
          link: 'exit'
        }
      ];
    }
  },
  methods: {
    async refresh() {
      await Promise.all([this.$store.dispatch('set_partnerInfo'), this.getOverview()]);
    },
    async getOverview() {
      const res = await services.partner.getOverview();
      this.scoreInfo = res.data;
    },
    async toLink(path) {
      await checkLogin();

      if (path === 'opinion') {
        this.opinionModel.show = true;
      } else if (path === 'qrcode') {
        this.qrcodeModel.show = true;
        this.qrcodeModel.info = {
          code: inviteUrl('partnerInviteEdit', this.partnerId),
          text: `${process.env.VUE_APP_TITLE} - ${this.partnerInfo.sales.name}`
        };
      } else if (path === 'exit') {
        signOut();
      } else {
        path && this.$router.push(path);
      }
    },
    dialPhoneNumber(phoneNumber) {
      window.location.href = 'tel:' + phoneNumber;
    }
  }
};
</script>

<style lang="scss" scoped>
.partner-info {
  .line-title {
    margin: $tb $lr 0px;
  }
  // padding: $tb $lr;
  .ach-panel {
    .ach-warp {
      margin: $tb $lr;
      box-shadow: $box-shadow1;
      border-radius: $radius;
      overflow: hidden;
      background: #fff;
      color: #fff;

      .personal-info {
        // text-align: center;
        background: $btnbg;
        padding: $tb $lr;
        line-height: 30px;
        display: flex;

        .avatar {
          border-radius: 50%;
          width: 70px;
          height: 70px !important;
          border: 2px solid #fff;
          margin-right: $lr;
          overflow: hidden;
        }
        .personal-right {
          .personal-name {
            font-size: 20px;
            font-weight: 600;
            margin-top: 10px;
          }
          .personal-tel {
            font-size: $size4;
          }
        }
      }

      .ach-content {
        display: flex;
        justify-content: space-around;
        padding: $tb $lr;
        > div {
          flex: 1;
          text-align: center;
          border-right: 2px solid $bordercolor;
          &:last-child {
            border-right: none;
          }
        }
        .ach-title {
          color: $gray2;
          font-size: $size6;
        }
        .ach-num {
          font-size: 16px;
          padding-top: $tb;
          text-align: center;
          color: $black1;
          font-size: $size5;
        }
      }
      // > div {
      //   text-align: center;
      //   .ach-title {
      //     font-size: $size4;
      //     color: $gray2;
      //     margin-bottom: $tb;
      //     font-weight: 600;
      //   }
      //   .ach-num {
      //     font-size: 24px;
      //     font-weight: 600;
      //     color: $black1;
      //   }
      // }
    }
  }
}
</style>
